// Microphone input level (0..1) as a horizontal bar. Purely visual feedback.
interface LevelMeterProps {
  level: number;
  /** Dimmed while paused / not recording. */
  inactive?: boolean;
  className?: string;
}

export function LevelMeter({ level, inactive, className }: LevelMeterProps) {
  const value = Math.min(1, Math.max(0, Number.isFinite(level) ? level : 0));
  return (
    <div className={`level${inactive ? ' level--inactive' : ''}${className ? ` ${className}` : ''}`} aria-hidden="true">
      <div className="level__fill" style={{ transform: `scaleX(${value.toFixed(3)})` }} />
    </div>
  );
}
